<template>
  <div class="locations-discount-terminals">
    <h3>
      Отправить груз можно в {{ filialText }} ТК Vozovoz:
    </h3>
    <div v-for="terminal in terminals" class="locations-discount-terminal flex flex-align-items-start mt-20">
      <vz-icon
        variant="primary"
        name="map-marker"
        class="mr-5"
      />
      <div class="w-100">
        {{ terminal.address }} 
        {{ terminal?.note ? ` (${terminal.note})` : '' }}
        <div class="locations-discount-terminals-schedule flex mt-10 mb-20">
          <div v-for="item in getSchedule(terminal)" class="schedule-item">
            {{ item.day }}
            <div v-html="item.time" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {PropType} from "vue"
import {Terminal} from "~/types/types"
import {daysOfWeeks} from "~/common/date"

const props = defineProps({
  terminals: {
    type: Array as PropType<Terminal[]>,
    default: () => []
  }
})

const filialText = computed(() => {
  return `филиал${props.terminals?.length > 1 ? 'ах' : 'е'}`
})

function getSchedule(terminal: Terminal) {
  const data: { day: string, time: string }[] = []
  const {timetable} = terminal

  if (!timetable) {
    return data
  }

  daysOfWeeks.forEach(element => {
    const table = timetable[element.eng] || timetable.workday
    const fullDay = table.from === '00:01' && table.to === '23:59'
    const time = !table.isWorking
      ? '-'
      : fullDay ? '24 часа' : `${table.from}<br>${table.to}`
    data.push({
      day: element.short,
      time
    })
  })
  data.push(data.shift())
  return data
}
</script>

<style lang="scss" scoped>
.locations-discount-terminals {
  .vz-icon {
    margin-top: 3px;
  }

  &-schedule {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 5px;
    color: $font-low;

    @media screen and (max-width: $pa-xxs) {
      grid-template-columns: repeat(2, 1fr);
    }

    .schedule-item {
      text-align: center;
      border-radius: 4px;
      padding: 7px 5px;
      border: 1px solid $border-gray;
      height: 70px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      div {
        font-size: 12px;
        line-height: 16px;
      }
    }
  } 
}
</style>
